export const MODULE_PATH = "configuration";
export const INTEGRATIONS_REDIRECT = `/s/${MODULE_PATH}`;

export const DEVELOPERS = `/s/${MODULE_PATH}/developers`;
export const API_KEYS = `/s/${MODULE_PATH}/developers/apiKeys`;
export const WEBHOOKS = `/s/${MODULE_PATH}/developers/webhooks`;

export const INTEGRATIONS = `/s/${MODULE_PATH}/integrations`;
export const FRAME_WEB = `/s/${MODULE_PATH}/integrations/FWB`;
export const FRAME_WEB_SUBSCRIPTION = `/s/${MODULE_PATH}/integrations/FWS`;
export const STRIPE = `/s/${MODULE_PATH}/integrations/STR`;
export const REDSYS = `/s/${MODULE_PATH}/integrations/RED`;
export const ASWIN = `/s/${MODULE_PATH}/integrations/ASW`;
export const ASWIN_GENERIC = `/s/${MODULE_PATH}/integrations/ASG`;
export const ASWIN_TEXT = `/s/${MODULE_PATH}/integrations/AWN`;
export const HUBSPOT = `/s/${MODULE_PATH}/integrations/HUB`;
export const CLIENTIFY = `/s/${MODULE_PATH}/integrations/CLI`;
export const QUITER = `/s/${MODULE_PATH}/integrations/ASQ`;
export const QUITER_W = `/s/${MODULE_PATH}/integrations/ASQW`;
export const QUITER_API = `/s/${MODULE_PATH}/integrations/QIS`;
export const AELIS = `/s/${MODULE_PATH}/integrations/AEL`;
export const SII = `/s/${MODULE_PATH}/integrations/SII`;
export const MAGNIFINANCE = `/s/${MODULE_PATH}/integrations/MAG`;
export const LODGING = `/s/${MODULE_PATH}/integrations/HOS`;
export const KEYLOOP = `/s/${MODULE_PATH}/integrations/KEY`;
export const MERLOS = `/s/${MODULE_PATH}/integrations/MEL`;
export const WALCU = `/s/${MODULE_PATH}/integrations/WLC`;
export const AUTOLINE = `/s/${MODULE_PATH}/integrations/AUT`;
export const HOLDED = `/s/${MODULE_PATH}/integrations/HDA`;
export const CONTASOL = `/s/${MODULE_PATH}/integrations/SOL`;
export const ODOO = `/s/${MODULE_PATH}/integrations/ODO`;

export const FAQS = `/s/${MODULE_PATH}/faqs`;
export const FAQS_DETAIL = `/s/${MODULE_PATH}/faqs/detail`;
export const FAQS_FORM = `/s/${MODULE_PATH}/faqs/form`;

export const LEGAL = `/s/${MODULE_PATH}/legal`;
export const LEGAL_TERMS = `/s/${MODULE_PATH}/legal/terms`;
export const LEGAL_PRIVACY_POLITIC = `/s/${MODULE_PATH}/legal/policy`;

export const EMAIL = `/s/${MODULE_PATH}/email`;

export const ROLES = `/s/${MODULE_PATH}/roles`;
export const ROLES_TYPES = `/s/${MODULE_PATH}/roles/types`;
export const ROLE_FORM = `/s/${MODULE_PATH}/roles/form`;
export const ROLE_DETAIL = `/s/${MODULE_PATH}/roles/detail`;

export const TAGS = `/s/${MODULE_PATH}/tags`;

export const BUDGETS_TERMS_AND_CONDITIONS = `/s/${MODULE_PATH}/budgets`;

export const INVOICE_ISSUER = `/s/${MODULE_PATH}/billing`;
export const PAYMENT_METHODS = `/s/${MODULE_PATH}/paymentMethods`;
export const GENERAL = `/s/${MODULE_PATH}/paymentMethods/general`;
export const BY_BRANCH = `/s/${MODULE_PATH}/paymentMethods/byBranch`;
